import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { ISection } from '../../models/group-edit-config';
import { FormBuilder, FormGroup } from '@angular/forms';
import { CompanyService } from '../../../../services/company.service';

@Component({
  selector: 'app-asset-group-editor',
  templateUrl: './asset-group-editor.component.html',
  styleUrls: ['./asset-group-editor.component.scss']
})
export class AssetGroupEditorComponent implements OnInit {
    @Input() group: any;
    @Input() set company(c: any){
        this._company = c;
        this.updateValidity();
        console.log("AssetGroupEditor company is being assigned...");
    }

    @Output() groupDeleted = new EventEmitter<any>();

    _company: any;

    depSection: ISection;
    dispSection: ISection;
    yeSection: ISection;
    form: FormGroup;
    selectedSection: any;
    isValid = false;
    mappingData: any;

    constructor(private fb: FormBuilder,
        private comp: CompanyService
    ) { }

    ngOnInit(): void {
        this.form = this.fb.group({});
        const data = this.getAssetGroupMappingData();
        this.mappingData = data;
        this.updateValidity();

        this.depSection = {
            header: 'Depreciation mappings',
            isChild: true,
            allowEdit: false,
            form: this.form,
            items:[
                {label: 'Additions', fieldName: 'transactions', control:'input'},
                {label: "Depreciation in year", fieldName: 'depreciationInYear', control:'input'},
                {label: "Depreciation expense", fieldName: 'depreciationExpense', control:'input'},
            ],
            data: data
        };

        this.dispSection = {
            header: 'Disposal mappings',
            isChild: true,
            allowEdit: false,
            form: this.form,
            items:[
                {label: 'Disposal cost', fieldName: 'disposalCost', control:'input'},
                {label: "Disposal depreciation", fieldName: 'disposalDep', control:'input'},
                {label: 'Disposal gain/loss', fieldName: 'disposalPnl', control:'input'},
            ],
            data: data
        };

        this.yeSection = {
            header: 'Year-end mappings',
            isChild: true,
            allowEdit: false,
            form: this.form,
            items:[
                {label: 'Brought forward cost', fieldName: 'costBf', control:'input'},
                {label: "Brought forward depreciation", fieldName: 'depreciationBf', control:'input'},
            ],
            data: data
        }
    }

    updateValidity() {
        if(this.mappingData){
            this.isValid = this.mappingData.transactions != '** MISSING' && 
                this.mappingData.depreciationInYear != '** MISSING' && 
                this.mappingData.depreciationExpense != '** MISSING' &&
                this.mappingData.disposalCost != '** MISSING' &&
                this.mappingData.disposalDep != '** MISSING' &&
                this.mappingData.disposalPnl != '** MISSING';

            if(this._company.useYearEndJournals){
                this.isValid = this.isValid && this.mappingData.costBf != '** MISSING' && this.mappingData.depreciationBf != '** MISSING';
            }
        }
    }

    getAssetGroupMappingData(): any {
        const data = {
            transactions: this.getAccountName('Transactions'),
            depreciationInYear: this.getAccountName('DepreciationInYear'),
            depreciationExpense: this.getAccountName('DepreciationExpenses'),
            disposalCost: this.getAccountName('DisposalsCost'),
            disposalDep: this.getAccountName('DisposalsDep'),
            disposalPnl: this.getAccountName('DisposalsPnl'),
            costBf: this.getAccountName('CostBf'),
            depreciationBf: this.getAccountName('DepreciationBf')
        };
        return data;
    }

    getAccountName(name: string){
        const item = this.group.mappings.find(x=>x.purpose === name);
        if(item){
            return item.nominalAccount;
        }else{
            return '** MISSING';
        }
    }

    async editGroup(){
        const result = await this.comp.updateAssetGroup(this.group.id);
        if(result){
            this.group = result;
            const data = this.getAssetGroupMappingData();
            this.mappingData = data;
            this.updateValidity();
            const depSection = {...this.depSection, data: data};
            const dispSection = {...this.dispSection, data: data};
            const yeSection = {...this.yeSection, data: data};
            this.depSection = null;
            this.dispSection = null;
            this.yeSection = null;
            setTimeout(()=>{
                this.depSection = depSection;
                this.dispSection = dispSection;
                this.yeSection = yeSection;
            }, 50);
        }
        
    }

    async deleteGroup(){
        if(this.group.hasAssets){
            alert("This asset group has assets assigned and cannot be deleted. Please reassign or delete the assets before deleting the group.");
            return;
        }
        const res = await this.comp.deleteAssetGroup(this.group.id);
        if(res){
            this.groupDeleted.emit(this.group.id);
        }
    }

}
